// extracted by mini-css-extract-plugin
export default {"form":"ChangeForm__form--2pK","error":"ChangeForm__error--2St","captcha":"ChangeForm__captcha--3K3"};